 <template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">
        <img src="../../assets/images/err.png" alt="">
        <p>客户注销须知</p>
      </div>
    </header>
    <div class="add-body">
        <p>1、您需依照dopay钱包账户注销流程和页面的提示将该账户涉及的相关事项处理完毕后进行注销。dopay钱包账户注销后，您将无法使用dopay钱包的服务，您与dopay钱包在《dopay钱包服务协议》项下约定的权利义务终止（前述协议另有约定不得终止的或依其性质不能终止的除外），同时还可能对该账户产生如下结果</p>
        <p>(1)身份信息、账户信息将被清空无法恢复；</p>
        <p>(2)交易记录将被清空，历史交易无法通过该账户进行退款；</p>
        <p>(3)银行卡的快捷支付将被自动关闭，您将无法使用快捷支付或提现服务；</p>
        <p>(4)充值、转账、提现功能将无法使用；</p>
        <p>(5)账户内的礼品券、积分、优惠券、其他权益等均将作废；</p>
        <p>(6)签约的商户服务将会同步解约，如：金小店；</p>
        <p>(7)签约的服务商服务将会同步解约；</p>
        <p>(8)开通的网商银行账号将会同步解绑；</p>
        <p>(9)开通的商城服务将被关闭；</p>
        <p>2、您申请注销的dopay钱包账户应当是您本人依照《dopay钱包服务协议》的约定进行注册并使用的账户。该账户应当处于正常状态，即您的dopay钱包账户的账户信息是最新、完整、正确的，且该账户未被采取止付、有权机关冻结等限制措施。如您是企业用户，申请注销的账户有关联账户的，在该等关联账户被注销前，该账户不得被注销。</p>
        <p>3、为了维护您和其他用户的合法利益，在您申请注销dopay钱包账户时，dopay钱包会进行风险审查，您的账户应当不存在未完结交易或其他未了结的权利义务，且不存在其他因注销可能引发的情况。如您的账户有余额等资产，请您在注销前先将您的账户下对应的可用款项全部提现，或者通过转账、消费等途径支用完毕。</p>
        <p>4、请您理解，您申请注销dopay钱包账户时，如果dopay钱包尚在或需要对您的有关交易或账户进行核查的，dopay钱包有权继续冻结您的dopay钱包账户或账户内全部或部分资金以便继续核查，并在必要时有权向监管或司法部门举报欺诈或非法行为。</p>
        <p>5、本须知未尽事宜，参照《dopay钱包服务协议》执行</p>
        <p><el-checkbox v-model="checked" class="myRedCheckBox"></el-checkbox>我已在注销dopay钱包账户前，充分阅读、理解并同意下列内容！</p>
        <el-button type="primary" @click="outNowsing" v-if="checked">确认注销</el-button>
        <el-button type="info" plain disabled style="display:flex;margin: 50px auto" v-else>确认注销</el-button>
    </div>
    <el-dialog
        title="注销"
        class="nowsing"
        :visible.sync="dialogVisible"
        @close='closeDialog'
        width="30%">
        <h3>账号名：{{ customerName }}</h3>
        <p>注销后，账户不可恢复。如有疑问，请联系客服：400-6969619</p>
        <p>{{ this.auditDetail.remark }}</p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="cancellation">注 销</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { customeCancel, queryAuditDetail, queryDetailCustomer } from '@/api/security/security'
import Session from '@/utils/session'
export default {
  data() {
    return {
      checked: false,
      dialogVisible: false,
      isDisabled: false,
      customerName: Session.getItem('customerName'),
      auditDetail: {}
    }
  },
  methods: {
    outNowsing() {
      if (this.checked) {
        this.queryDetailCustomer()
        this.dialogVisible = true
        this.auditDetail = {}
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.checked = false
    },

    // 查询是否是临时客户
    queryDetailCustomer() {
      const param = {
        customerId: Session.getItem('customerId')
      }
      queryDetailCustomer(param)
        .then(res => {
          if (res.data.code) {
            this.queryAuditDetail()
          }
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 查询注销决绝原因
    queryAuditDetail() {
      const param = {
        customerCode: Session.getItem('customerCode')
      }
      queryAuditDetail(param)
        .then(res => {
          this.auditDetail = res.data
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    cancellation() {
      if (this.auditDetail.auditStatus === '1') {
        this.$message.error('您的注销申请正在审核中，请耐心等待！')
        return
      }
      const param = {
        customerId: Session.getItem('customerId')
      }
      customeCancel(param)
        .then(res => {
          // console.log(res)
          this.dialogVisible = false
          this.checked = false
          this.logout()
        })
        .catch(error => {
          this.dialogVisible = false
          this.checked = false
          console.log(error) // 请求失败返回的数据
        })
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      await this.$router.push({ path: '/login' })
      localStorage.removeItem('customerLength')
      localStorage.removeItem('operLength')
      sessionStorage.removeItem('showTrue')
      sessionStorage.removeItem('showBanklist')
    }
  }
}
</script>
<style scoped>
.bN .el-input__inner {
  border: none;
  padding: 0;
}
</style>
<style scoped>
.add {
  padding-bottom: 118px;
}
.bN .el-input__inner {
  border: none;
}
.headet-title {
  padding: 10px 30px 20px 30px;
}
.headet-title .headet-title-box {
  font-size: 16px;
  padding: 10px 0;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  border-bottom: 1px solid #dbdde2;
}
.headet-title-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.headet-title-box img{
    width: 30px;
    height: 30px;
    margin-right: 10px;
}
.headet-title-box > p:first-of-type {
  margin-right: 26px;
}
.add-body{
    padding: 0 30px;
}
.add-body ::v-deep .el-input__inner {
  height: 32px;
  font-size: 13px;
  line-height: 36px;
  border-radius: 0px;
}
li{
    list-style: none;
    line-height: 40px;
}
::v-deep .el-checkbox__inner{
    /* background-color: #498aea !important;
    border: 1px solid #498aea !important; */
    margin-right: 10px;
}
::v-deep .el-button--primary{
    margin: 0 auto;
    display: flex;
    margin-top: 50px;
    background-color: #498aea;
    border: 1px solid #498aea;
}
.nowsing h3{
    height: 50px;
    border-bottom: 1px solid #ccc;
}
::v-deep .el-dialog__body{
    padding: 0 20px;
}
/* 设置带边框的checkbox，选中后边框的颜色 */
::v-deep .myRedCheckBox.is-bordered.is-checked {
  border-color: #498aea !important;
}

/* 设置选中后的文字颜色 */
::v-deep .myRedCheckBox .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #498aea !important;
}

/* 设置选中后对勾框的边框和背景颜色 */
::v-deep .myRedCheckBox .el-checkbox__input.is-checked .el-checkbox__inner, .myRedCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #498aea !important;
  background-color:#498aea !important;
}

/* 设置checkbox获得焦点后，对勾框的边框颜色 */
::v-deep .myRedCheckBox .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #498aea !important;
}

/* 设置鼠标经过对勾框，对勾框边框的颜色 */
::v-deep .myRedCheckBox .el-checkbox__inner:hover{
  border-color: #498aea !important;
}
</style>
